var DialogLocationSectorModule = /** @class */ (function () {
    function DialogLocationSectorModule() {
    }
    return DialogLocationSectorModule;
}());
export { DialogLocationSectorModule };
